import api from './order-api';
import tools from './order-tools';

const order = () => {
    // Отключаем восстановление скролла
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    const steps = {
        getStepTwoFormForGuests: async (val) => {
            const elPaymentAddress = document.getElementById('payment-address-sections-group');
            if (!elPaymentAddress) throw new Error("Element '#payment-address-sections-group' not found");

            try {
                const html = await api.fetchData(`index.php?route=checkout/${val}`);

                elPaymentAddress.innerHTML = html;
                tools.regionHandlerInPaymentAddress();

                // Очищаем другие секции
                ['shipping-address-sections-group', 'shipping-payment-sections-group', 'shipping-method-sections-group']
                    .forEach(id => {
                        const el = document.getElementById(id);
                        if (el) el.innerHTML = '';
                    });

                let checkbox_a = document.getElementById('guest-agree-checkbox');
                let submitButton_a = document.getElementById('button-guest');
                if (val === 'register') {
                    checkbox_a = document.getElementById('agree-checkbox');
                    submitButton_a = document.getElementById('button-register');
                }

                if (checkbox_a && submitButton_a) {
                    // Установка начального состояния
                    submitButton_a.disabled = !checkbox_a.checked;

                    // Обработка изменения чекбокса
                    checkbox_a.addEventListener('change', function () {
                        submitButton_a.disabled = !this.checked;
                    });
                }
            } catch (error) {
                console.error(`Ошибка получения формы для гостей: ${error.message}`);
            }
        },

        saveShippingAddress: async () => {
            const shippingAddressForm = document.querySelector('#shipping-address-sections-group');

            if (shippingAddressForm) {
                const formData = new FormData(shippingAddressForm);
                const params = new URLSearchParams(formData).toString();
                try {
                    const json = await api.postData('index.php?route=checkout/shipping_address/save', params);

                    if (json.redirect) {
                        location.href = json.redirect;
                    } else if (json.error) {
                        console.error(`Ошибка сохранения скрытого адреса доставки: ${json.error}`);
                    } else {
                        console.log("Скрытый адрес доставки успешно сохранён!");
                    }
                } catch (error) {
                    console.error(`Ошибка запроса сохранения скрытого адреса доставки: ${error.message}`);
                }

            } else {
                const formData = new FormData(document.querySelector('#dl-payment-address-form'));
                const params = new URLSearchParams(formData).toString();
                try {
                    const json = await api.postData('index.php?route=checkout/shipping_address/save_alt', params);

                    if (json.redirect) {
                        location.href = json.redirect;
                    } else if (json.error) {
                        console.error(`Ошибка сохранения скрытого адреса доставки: ${json.error}`);
                    } else {
                        console.log("Скрытый адрес доставки успешно сохранён!");
                        console.log(json);
                    }
                } catch (error) {
                    console.error(`Ошибка запроса сохранения скрытого адреса доставки: ${error.message}`);
                }
            }

        },

        getPaymentButton: async () => {
            // Отправка способа доставки
            const shippingFormData = new FormData();
            shippingFormData.append('shipping_method', 'flat.flat');
            shippingFormData.append('comment', 'Текст комментария');
            const shippingFormDataParams = new URLSearchParams(shippingFormData).toString();
            const shipping_method_html = await api.fetchData('index.php?route=checkout/shipping_method').then(async () => {
                const response_from_shipping_method_save = await api.postData('index.php?route=checkout/shipping_method/save', shippingFormDataParams);
            });
            // TODO: обработать ошибки от response_from_shipping_method_save

            // Получение методов оплаты

            // Отправка способа оплаты
            const paymentFormData = new FormData();
            paymentFormData.append('payment_method', 'tbank');
            paymentFormData.append('agree', '1');
            const paymentFormDataParams = new URLSearchParams(paymentFormData).toString();
            const payment_method_html = await api.fetchData('index.php?route=checkout/payment_method');
            const response_from_payment_method_save = await api.postData('index.php?route=checkout/payment_method/save', paymentFormDataParams);
            // TODO: обработать ошибки от response_from_payment_method_save

            // Получение кнопки подтверждения заказа
            const html5 = await api.fetchData('index.php?route=checkout/confirm');
            document.getElementById('confirm-button-box').innerHTML = html5;
            const res = await api.fetchData('index.php?route=checkout/logs');
        },

        getPaymentAddresses: async (withEditButtons = false) => {
            const container = document.getElementById('payment-address-sections-group');
            if (!container) return;
            try {
                const html = await api.fetchData('index.php?route=checkout/payment_address');
                container.innerHTML = html;
                tools.regionHandlerInPaymentAddress();
                // Обработка смены формы
                const switchButton = document.getElementById('switch-payment-address');
                if (switchButton) {
                    switchButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        const state = switchButton.dataset.state;
                        if (state === 'existing') {
                            document.getElementById('logged-payment-address-existing').style.display = 'none';
                            document.getElementById('logged-payment-address-new').style.display = '';
                            switchButton.dataset.state = 'new';
                            switchButton.innerText = 'Выбрать сохранённый адрес';
                            document.querySelector('input[name="payment_address"][value="new"]').checked = true;
                        }
                        if (state === 'new') {
                            document.getElementById('logged-payment-address-existing').style.display = '';
                            document.getElementById('logged-payment-address-new').style.display = 'none';
                            switchButton.dataset.state = 'existing';
                            switchButton.innerText = 'Указать новый адреc';
                            document.querySelector('input[name="payment_address"][value="existing"]').checked = true;
                        }
                    });
                }

                const addressIdButtonsHandler = () => {
                    const addressButtons = document.querySelectorAll('input[name="address_id"] + label');
                    addressButtons.forEach((el) => {
                        el.addEventListener('click', () => {
                            const target = el.getAttribute('for');
                            document.getElementById(target).checked = true;
                        });
                    });
                }

                if (!withEditButtons) {
                    addressIdButtonsHandler();
                } else {
                    document.getElementById('dl-logged-payment-address-confirm-buttons-group').style.display = 'none';
                    document.getElementById('dl-logged-payment-address-edit-buttons-group').style.display = '';
                    document.getElementById('edit-logged-payment-address').addEventListener('click', () => {
                        document.getElementById('dl-logged-payment-address-confirm-buttons-group').style.display = '';
                        document.getElementById('dl-logged-payment-address-edit-buttons-group').style.display = 'none';
                        document.getElementById('confirm-button-box').innerHTML = '';
                        addressIdButtonsHandler();
                    });
                }
            } catch (error) {
                console.error(`Ошибка получения адресов: ${error.message}`);
            }
        },
    };

    const orderContainer = document.getElementById('order-container');
    if (!orderContainer) return;
    console.log('Работает новый скрипт оформления заказа!');

    const isLogged = +orderContainer.dataset.logged;

    if (isLogged === 0) {
        steps.getStepTwoFormForGuests('guest');
        document.querySelectorAll('#account-fieldset .Field-radiobutton__hidden-input').forEach(input => {
            input.addEventListener('change', async function () {
                tools.save_data_for_guest_to_register();
                await steps.getStepTwoFormForGuests(this.value).then(() => {
                    tools.fill_data_for_guest_to_register();
                });
                const elPaymentAddress = document.getElementById('payment-address-sections-group');
                window.scrollTo({
                    top: tools.getOffsetTop(elPaymentAddress) - tools.getScrollMargin()
                });
                if (document.getElementById('confirm-button-box')) {
                    document.getElementById('confirm-button-box').innerHTML = '';
                }
            });
        });
    }


    const paymentAddressSectionsGroup = document.getElementById('payment-address-sections-group');
    paymentAddressSectionsGroup.addEventListener('click', async (e) => {
        if (e.target.closest('#button-guest')) {
            const guestErrorFields = tools.getErrorFields();

            try {
                // Получаем данные формы
                const formData = new FormData(document.querySelector('#dl-guest-payment-address'));
                const params = new URLSearchParams(formData).toString();

                const response = await api.postData('index.php?route=checkout/guest/save', params);
                tools.clearErrors();

                if (response.redirect) {
                    location.href = response.redirect;
                } else if (response.error) {
                    console.log(response.error);
                    tools.clearErrors();
                    // Отображение ошибок
                    for (const [key, field] of Object.entries(guestErrorFields)) {
                        if (response.error[key]) field.innerText = response.error[key];
                        console.log(`Установка ошибки: ${response.error[key]}`);
                    }
                } else {
                    const shippingAddress = document.querySelector('#dl-guest-payment-address input[name="shipping_address"]:checked')?.value;
                    if (shippingAddress) {
                        // Фиксируем контактные данные
                        const html1 = await api.fetchData('index.php?route=checkout/guest_fixed');
                        document.getElementById('payment-address-sections-group').innerHTML = html1;

                        steps.getPaymentButton();
                    }
                }
            } catch (error) {
                console.log(`Ошибка: ${error.message}`);
            }
        } else if (e.target.closest('#edit-guest-fixed-button')) {
            tools.save_data_for_edit_guest();
            document.getElementById('confirm-button-box').innerHTML = '';
            await steps.getStepTwoFormForGuests('guest').then(() => {
                tools.fill_data_for_edit_guest();
            });
        } else if (e.target.closest('#button-register')) {
            const registerErrorFields = tools.getErrorFields();

            try {
                // Получаем данные формы
                const formData = new FormData(document.querySelector('#dl-register-payment-address'));
                const params = new URLSearchParams(formData).toString();

                const response = await api.postData('index.php?route=checkout/register/save', params);
                tools.clearErrors();

                if (response.redirect) {
                    location.href = response.redirect;
                } else if (response.error) {
                    console.log(response.error);
                    tools.clearErrors();
                    // Отображение ошибок
                    for (const [key, field] of Object.entries(registerErrorFields)) {
                        if (response.error[key]) field.innerText = response.error[key];
                        console.log(`Установка ошибки: ${response.error[key]}`);
                    }
                } else {
                    // РАБОТАТЬ ЗДЕСЬ ↓↓↓
                    const container = document.getElementById('register-user-data-sections-group');
                    if (!container) return;
                    // Заполняем данные покупателя
                    try {
                        const html = await api.fetchData('index.php?route=checkout/register_fixed');
                        container.innerHTML = html;
                        // Проставляем адрес
                        try {
                            const html = await api.fetchData('index.php?route=checkout/payment_address_fixed');
                            paymentAddressSectionsGroup.innerHTML = html;

                            steps.getPaymentButton();
                        } catch (error) {
                            console.log(`Ошибка: ${error.message}`);
                        }
                    } catch (error) {
                        console.log(`Ошибка: ${error.message}`);
                    }

                    // РАБОТАТЬ ЗДЕСЬ ↑↑↑
                }
            } catch (error) {
                console.log(`Ошибка: ${error.message}`);
            }
        }
    });

    // Оформление заказа зарегистрированным пользователем
    if (isLogged !== 0) {
        steps.getPaymentAddresses();
        document.getElementById('payment-address-sections-group').addEventListener('click', async (e) => {
            e.preventDefault();
            if (e.target.closest('#button-payment-address')) {
                steps.saveShippingAddress();
                const payment_address_error_fields = tools.getErrorFields();

                try {
                    // Получаем данные формы
                    const formData = new FormData(document.querySelector('#dl-payment-address-form'));
                    const params = new URLSearchParams(formData).toString();

                    const response = await api.postData('index.php?route=checkout/payment_address/save', params);
                    tools.clearErrors();

                    if (response.redirect) {
                        location.href = response.redirect;
                    } else if (response.error) {
                        console.log(response.error);
                        tools.clearErrors();
                        // Отображение ошибок
                        for (const [key, field] of Object.entries(payment_address_error_fields)) {
                            if (response.error[key]) field.innerText = response.error[key];
                            console.log(`Установка ошибки: ${response.error[key]}`);
                        }
                    } else {
                        const shippingAddress = document.querySelector('#dl-payment-address-form input[name="shipping_address"]:checked')?.value;
                        if (shippingAddress) {
                            steps.getPaymentButton();
                            steps.getPaymentAddresses(true);
                        }
                    }
                } catch (error) {
                    console.log(`Ошибка: ${error.message}`);
                }
            }
        });
    }
};

export default order;

